import React from 'react';
import '../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-container">
      {/* About Us Content Section with White Background Box */}
      <div className="about-content-wrapper">
        
        <div className="about-content">
          <div className="about-header">
            <h1>About Us</h1>
          </div>
          
          <div className="about-welcome">
            <h2>Welcome to Turtles Bay</h2>
            <p className="welcome-text">Come, leave the noise behind — and find your paradise at Turtles Bay.</p>
            <div className="divider"></div>
          </div>

          <div className="about-details">
            <div className="about-text">
              <p>
                Nestled on the shores of Kadmat Island in Lakshwadeep, our boutique resort features 
                six sea-facing rooms, each designed for comfort, privacy, and breathtaking ocean 
                views. We believe that the best experiences come from simplicity — waking up to the 
                sound of the waves, walking barefoot on soft white sand, and feeling the warm 
                island breeze all around you.
              </p>
              <p>
                At Turtles Bay, we focus on personalized hospitality, local flavors, and unforgettable 
                island adventures. Whether you're here to snorkel among vibrant coral reefs, relax by 
                the lagoon, or simply slow down and soak in the beauty of nature, we're here to make 
                your stay truly special.
              </p>
            </div>
            <div className="about-image">
              <img src="/images/room-view.jpeg" alt="Room with ocean view" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;